import { db } from '../../firebase';
// xross interface
import { NGWord } from '$common/interface';
// コレクション名定義
import { CL_NGWORDS } from '../../common/define';

//
// NGワードを取得する
//
export const getNgWords = async () => {
  const docid = 'ngwordlist';
  try {
    const snapshot = await db.collection(CL_NGWORDS).doc(docid).get();
    const ngword = snapshot.data() as NGWord;

    console.log('ngwords = ', ngword);

    if (!ngword) {
      console.log('No NG words found');
      return [];
    }
    console.log('ngwords = ', ngword.list);
    return ngword.list;
  } catch (err) {
    console.log('getNgWords error >> ', err);
    return null;
  }
};

//
// NGワードを登録する
//
export const changeNgWords = async (updatedList: string[]) => {
  const docid = 'ngwordlist';
  await db.collection(CL_NGWORDS).doc(docid).set({ list: updatedList });
};
